module.exports = __webpack_public_path__ + "img/584.b79c32b0.png";